(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    if (window.LeadbellySectionNavInstalled) return;
    window.LeadbellySectionNavInstalled = true;
    document.addEventListener('click', function (event) {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      let destination;
      try {
        destination = new URL(link.getAttribute('href'), window.location.href);
      } catch (error) {
        return;
      }
      if (destination.origin !== window.location.origin ||
          destination.pathname !== '/' ||
          !destination.hash.startsWith('#lb-')) return;
      const sectionId = destination.hash.slice(1);
      const section = document.getElementById(sectionId);
      if (!section) {
        if (window.location.pathname !== '/') {
          event.preventDefault();
          const homepage = new URL('/', window.location.origin);
          const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewThemeId) homepage.searchParams.set('preview_theme_id', previewThemeId);
          homepage.hash = destination.hash;
          window.location.assign(homepage.href);
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const drawer = link.closest('header-drawer');
      if (drawer) {
        const menu = drawer.mainDetailsToggle || drawer.querySelector('details');
        const summary = menu && menu.querySelector('summary');
        if (summary && typeof drawer.closeMenuDrawer === 'function') {
          try {
            drawer.closeMenuDrawer(event, summary);
          } catch (error) {
          }
        }
        drawer.querySelectorAll('details[open]').forEach(function (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening', 'submenu-open');
        });
        drawer.querySelectorAll('.menu-opening, .submenu-open').forEach(function (element) {
          element.classList.remove('menu-opening', 'submenu-open');
        });
        drawer.querySelectorAll('summary[aria-expanded="true"]').forEach(function (element) {
          element.setAttribute('aria-expanded', 'false');
        });
        const header = drawer.closest('.section-header');
        if (header) header.classList.remove('menu-open');
        document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
      } else {
        const openedDetails = link.closest('details[open]');
        if (openedDetails) openedDetails.removeAttribute('open');
      }
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search + destination.hash);
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.requestAnimationFrame(function () {
        section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }, true);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leadbelly-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeGalleries() {
    document.querySelectorAll('.lb-site').forEach(function (root) {
      if (root.dataset.galleryReady === 'true') return;
      var dialog = root.querySelector('.lb-lightbox');
      var buttons = Array.from(root.querySelectorAll('.lb-gallery-open'));
      if (!dialog || !buttons.length) return;
      root.dataset.galleryReady = 'true';
      var photograph = dialog.querySelector('.lb-lightbox-photo');
      var label = dialog.querySelector('.lb-lightbox-caption');
      var count = dialog.querySelector('.lb-lightbox-count');
      var activeIndex = 0;
      var trigger = null;
      function show(index) {
        activeIndex = (index + buttons.length) % buttons.length;
        var button = buttons[activeIndex];
        var thumbnail = button.querySelector('img');
        photograph.src = button.getAttribute('data-lb-full') || thumbnail.currentSrc || thumbnail.src;
        photograph.alt = thumbnail.alt || 'Leadbelly Metalworks project photo';
        label.textContent = button.closest('figure').querySelector('figcaption').textContent.trim();
        count.textContent = (activeIndex + 1) + ' / ' + buttons.length;
      }
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          trigger = button;
          show(index);
          if (typeof dialog.showModal === 'function') {
            if (!dialog.open) dialog.showModal();
            dialog.querySelector('.lb-lightbox-close').focus();
          } else {
            window.open(photograph.src, '_blank', 'noopener');
          }
        });
      });
      dialog.querySelector('.lb-lightbox-close').addEventListener('click', function () { dialog.close(); });
      dialog.querySelector('.lb-lightbox-prev').addEventListener('click', function () { show(activeIndex - 1); });
      dialog.querySelector('.lb-lightbox-next').addEventListener('click', function () { show(activeIndex + 1); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(activeIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(activeIndex + 1); }
      });
      dialog.addEventListener('close', function () {
        photograph.removeAttribute('src');
        if (trigger) trigger.focus({preventScroll: true});
      });
      var touchStartX = null, touchStartY = null;
      photograph.addEventListener('touchstart', function (event) {
        if (!event.changedTouches.length) return;
        touchStartX = event.changedTouches[0].screenX;
        touchStartY = event.changedTouches[0].screenY;
      }, {passive: true});
      photograph.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].screenX - touchStartX;
        var dy = event.changedTouches[0].screenY - touchStartY;
        touchStartX = null; touchStartY = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) show(activeIndex + (dx < 0 ? 1 : -1));
      }, {passive: true});
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGalleries);
  } else {
    initializeGalleries();
  }
  document.addEventListener('shopify:section:load', initializeGalleries);
})();

  } catch(e) { console.error(e); }
})();
})();
